import { useContext } from "react";
import { SiteContext } from "../contexts/SiteContext";
import { AppBar, Toolbar, makeStyles, Fade, Hidden } from "@material-ui/core";
import NavMenu from "./Menu";
import MenuDrawer from "./MenuDrawer";

function CustomAppBar() {
	const { selectedSite } = useContext(SiteContext);

	const useStyles = makeStyles((theme) => ({
		root: {
			flexGrow: 1,
			background: selectedSite.primaryColor
				? selectedSite.primaryColor
				: theme.palette.primary.main,
		},
		inner: {
			maxWidth: process.env.REACT_APP_MAX_WIDTH,
			margin: "0 auto",
		},
		toolbar: {
			background: selectedSite.primaryColor
				? selectedSite.primaryColor
				: theme.palette.primary.main,
		},
		title: {
			flexGrow: 1,
			textDecoration: "none",
			color: theme.palette.primary.contrastText,
		},
	}));

	const classes = useStyles();

	return (
		<Fade in={typeof selectedSite != "undefined"}>
			<div className={classes.root}>
				<AppBar className={classes.inner} elevation={0} position="static">
					<Toolbar className={classes.toolbar}>
						<Hidden mdUp>
							<MenuDrawer />
						</Hidden>
						<Hidden smDown>
							<NavMenu />
						</Hidden>
					</Toolbar>
				</AppBar>
			</div>
		</Fade>
	);
}

export default CustomAppBar;
